export const fontRegular = "'fakt-normal', sans-serif";
export const fontSemiBold = "'fakt-medium', sans-serif";
export const fontBold = "'fakt-semibold', sans-serif";
export const fontSerif = "'guardian-egyptian-light', serif";
export const fontSerifRegular = "'guardian-egyptian-regular', serif";
export const fontBuenosAiresRegular = "buenos-aires-regular";
export const fontBuenosAiresBold = "buenos-aires-bold";
//# sourceMappingURL=fonts.js.map